<template>
	<div class="control-group" :class="{filled: text && text.length > 0, active: focused, error: errors && errors.length > 0, disabled: disabled}">
		<div class="control-holder">
			<label v-if="label" :class="{'has-prepend': prependIcon}">{{ label }}<span v-if="required">*</span></label>
			<div class="input" :class="{'has-append': appendIcon, 'has-prepend': prependIcon}">
				<span v-if="prependIcon" @click.prevent="$emit('click:prepend')" class="prepend-icon"><i class="material-icons">{{ prependIcon }}</i></span>
				<div class="input-holder">
					<textarea
						@keyup.enter.stop=""
						@keydown.enter.stop=""
				        :disabled="disabled" 
				        :readonly="readonly"
				        v-model="text" 
				        :placeholder="(placeholder)?(placeholder + ((required)?'*':'')):''" 
				        :autocomplete="(autocomplete)?autocomplete:false" 
				        @click="$emit('focus')"
				        @focus="focused = true; $emit('focus')" 
				        @blur="focused = false; $emit('blur')" 
				        :style="{height: height + 'px'}"
					></textarea>
			    </div>
		    	<span v-if="appendIcon" @click.prevent="$emit('click:append')" class="append-icon"><i class="material-icons">{{ appendIcon }}</i></span>
		    </div>
		</div>
        <transition name="slide-down">
            <div class="error-text" v-if="errors && errors.length > 0">
                <div v-for="error in errors">{{ error }}</div>
            </div>
        </transition>
    </div>
</template>

<script>
	export default {
		props: ['value', 'label', 'errors', 'required', 'placeholder', 'disabled', 'appendIcon', 'prependIcon', 'autocomplete', 'readonly', 'height'],
		data() {
			return {
				text: this.value,
				focused: false
			}
		},
		watch: {
			text() {
				this.$emit('input', this.text);
			},
			value() {
				this.text = this.value;
				this.$emit('input', this.value);
			}
		}
	}
</script>